module.exports = __webpack_public_path__ + "img/discount.a974369b.svg";